import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import Footer from "@/components/Footer";
import { Send } from "lucide-react";

export default function Apply() {
  const nav = useNavigate();
  const [form, setForm] = useState({
    name: "",
    stage_name: "",
    email: "",
    phone: "",
    city: "",
    discipline: "",
    experience_years: "",
    is_emerging: false,
    bio: "",
    portfolio_url: "",
    social_urls: "",
    demo_url: "",
    photo_url: "",
    availability: "",
  });
  const [sending, setSending] = useState(false);

  const upd = (k) => (e) =>
    setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/artist-applications", {
        ...form,
        experience_years: form.experience_years ? Number(form.experience_years) : null,
      });
      toast.success("Candidatura inviata ✦ ti risponderemo a breve");
      nav("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="pt-28 pb-16">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="av-eyebrow">Candidati al roster NMA</span>
        <h1 className="font-serif-display text-4xl sm:text-6xl mt-3 leading-tight">
          Cerchiamo <span className="italic text-[#E5A93C]">talenti</span>.<br />
          Anche <span className="italic text-[#E5A93C]">emergenti</span>.
        </h1>
        <p className="text-[#F7F4EE]/80 mt-6 leading-relaxed">
          Se hai una voce, un progetto o uno spettacolo pronto — o se stai muovendo i
          primi passi e cerchi chi ci crede — mandaci la tua candidatura. La ascoltiamo
          davvero.
        </p>

        <form onSubmit={submit} className="av-card p-6 lg:p-8 mt-10 space-y-4" data-testid="apply-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="av-label">Nome e cognome *</label>
              <input required className="av-input" value={form.name} onChange={upd("name")} data-testid="apply-name" />
            </div>
            <div>
              <label className="av-label">Nome d'arte</label>
              <input className="av-input" value={form.stage_name} onChange={upd("stage_name")} data-testid="apply-stage" />
            </div>
            <div>
              <label className="av-label">Email *</label>
              <input required type="email" className="av-input" value={form.email} onChange={upd("email")} data-testid="apply-email" />
            </div>
            <div>
              <label className="av-label">Telefono</label>
              <input className="av-input" value={form.phone} onChange={upd("phone")} data-testid="apply-phone" />
            </div>
            <div>
              <label className="av-label">Città</label>
              <input className="av-input" value={form.city} onChange={upd("city")} data-testid="apply-city" />
            </div>
            <div>
              <label className="av-label">Disciplina * (es. Cantautore, Danza…)</label>
              <input required className="av-input" value={form.discipline} onChange={upd("discipline")} data-testid="apply-discipline" />
            </div>
            <div>
              <label className="av-label">Anni di esperienza</label>
              <input type="number" min="0" className="av-input" value={form.experience_years} onChange={upd("experience_years")} data-testid="apply-years" />
            </div>
            <div className="flex items-end">
              <label className="flex items-center gap-2 text-sm text-[#F7F4EE]/90 cursor-pointer">
                <input type="checkbox" checked={form.is_emerging} onChange={upd("is_emerging")} data-testid="apply-emerging" className="accent-[#E5A93C]" />
                Sono un artista emergente
              </label>
            </div>
          </div>

          <div>
            <label className="av-label">Bio breve</label>
            <textarea rows={4} className="av-input" value={form.bio} onChange={upd("bio")} data-testid="apply-bio" placeholder="Chi sei, cosa fai, cosa ti muove" />
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="av-label">Link demo (YouTube, Spotify, video…)</label>
              <input className="av-input" value={form.demo_url} onChange={upd("demo_url")} data-testid="apply-demo" placeholder="https://" />
            </div>
            <div>
              <label className="av-label">Portfolio</label>
              <input className="av-input" value={form.portfolio_url} onChange={upd("portfolio_url")} data-testid="apply-portfolio" placeholder="https://" />
            </div>
            <div>
              <label className="av-label">Social</label>
              <input className="av-input" value={form.social_urls} onChange={upd("social_urls")} data-testid="apply-social" placeholder="Instagram, TikTok, YouTube…" />
            </div>
            <div>
              <label className="av-label">Foto profilo (URL)</label>
              <input className="av-input" value={form.photo_url} onChange={upd("photo_url")} data-testid="apply-photo" placeholder="https://" />
            </div>
          </div>

          <div>
            <label className="av-label">Disponibilità</label>
            <input className="av-input" value={form.availability} onChange={upd("availability")} data-testid="apply-availability" placeholder="Es. weekend, estate, tour" />
          </div>

          <button type="submit" disabled={sending} className="av-pill av-pill-gold w-full justify-center" data-testid="apply-submit">
            <Send size={14} /> {sending ? "Invio…" : "Invia candidatura"}
          </button>
        </form>
      </section>
      <Footer />
    </div>
  );
}
